import { Controller } from '@hotwired/stimulus';
import jQuery from 'jquery';
import { Foundation } from 'foundation-sites';
import * as timeago from 'timeago.js';

export default class PoolFormController extends Controller {
    static targets = ['modeToggle', 'select', 'date', 'panel'];
    static values = {
        mode: { type: String, default: 'existing' }
    };

    connect () {
        console.log('PoolClusterFormController.connect', this.modeValue);

        this.$clusterPanel = window.jQuery(this.panelTarget);
    }

    toggleMode (evt) {
        if (this.modeValue === 'existing') {
            console.log('showing cluster form, hiding picker');
            this.modeValue = 'new';

            this.modeToggleTarget.textContent = '(Select Existing)';
            this.selectTarget.value = '';
            this.selectTarget.setAttribute('disabled', 'disabled');
            this.$clusterPanel.slideDown();
            this.dateTarget.style.display = "none";
        } else {
            console.log('hiding cluster form, showing picker', this.selectTarget.dataset);
            this.modeValue = 'existing';

            this.$clusterPanel.slideUp();
            this.modeToggleTarget.textContent = '(Add New)';
            this.selectTarget.value = this.selectTarget.dataset.defaultClusterId;
            this.selectTarget.removeAttribute('disabled');
        }
    }

    static CLUSTER_SD_RE = /s\/d:/;

    changeCluster (value, prevValue) {
        console.log('cluster value changed', value, prevValue);

        const selectedIndex = this.selectTarget.selectedIndex;
        const selectedValue = this.selectTarget.options[selectedIndex].value;
        const selectedText = this.selectTarget.options[selectedIndex].text;

        var cName = this.selectTarget.value;
        console.log('cName', this.selectTarget, cName);
        // if (cName.match(sdRegex)) {
        console.log('cName', cName, cName.match(PoolFormController.CLUSTER_SD_RE), this.dateTarget);
        if (PoolFormController.CLUSTER_SD_RE.test(selectedText)) {
            this.dateTarget.style.display = "none";
        } else {
            this.dateTarget.style.display = "block"
        }
    }
}